import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, unref as _unref, vShow as _vShow, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "autocomplete-popup__container q-container-xl" }

import {toRefs} from 'vue';
import {usePopupStore} from "@/store/AutocompletePopup/PopupStore";

import AutocompleteContainer from '@/components/AutocompletePopup/ShowResults/AutocompleteContainer.vue';
import OnFocusContainer from '@/components/AutocompletePopup/OnFocus/OnFocusContainer.vue';
import ClosePopupButtonDestkop from "@/components/AutocompletePopup/ClosePopupButtonDestkop.vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'AutocompleteContainer',
  setup(__props) {

const popupStore = usePopupStore()
const {showResults} = toRefs(popupStore)

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(ClosePopupButtonDestkop),
    _withDirectives(_createVNode(OnFocusContainer, null, null, 512), [
      [_vShow, !_unref(showResults)]
    ]),
    _withDirectives(_createVNode(AutocompleteContainer, null, null, 512), [
      [_vShow, _unref(showResults)]
    ])
  ]))
}
}

})